import React from 'react';
import fbLogo from '../img/fb-logo.png';
import googleLogo from '../img/google-logo.png';
import { GOOGLE_AUTH_URL, FACEBOOK_AUTH_URL } from '../../../resources/api-constants';
import { getLastPath } from '../CookiesUtil';

const SocialLogin: React.FC = () => {
  const lastPath = getLastPath();

  const googleUrl = `${GOOGLE_AUTH_URL}?state=${lastPath}`;
  const facebookUrl = `${FACEBOOK_AUTH_URL}?state=${lastPath}`;

  return (
    <div className="mb-4">
      <button className="w-full bg-blue-600 text-white rounded-lg mt-4 mb-4 py-2 px-4 flex items-center justify-center">
        <a className="font-bold italic flex items-center" href={googleUrl}>
          <img src={googleLogo} alt="Google" className="h-5 mr-2" /> Login with Google
        </a>
      </button>

      <button className="w-full bg-blue-800 text-white rounded-lg mt-4 mb-4 py-2 px-4 flex items-center justify-center">
        <a className="font-bold italic flex items-center" href={facebookUrl}>
          <img src={fbLogo} alt="Facebook" className="h-5 mr-2" /> Login with Facebook
        </a>
      </button>

      {
        //<a className="btn btn-block social-btn github" href={GITHUB_AUTH_URL}>
        //   <img src={githubLogo} alt="Github" /> Login with Github</a>
      }
    </div>
  );
}

export default SocialLogin;